module.exports = __webpack_public_path__ + "static/media/bewell.b40e9cf1.png";